import { on } from 'delegated-events';
import helpers from './helpers';

/*
===================================================================
Image Block
===================================================================
*/
export default (function () {
  return {
    init() {
      const imageBlocks = document.querySelectorAll('.js-image-block');

      if (imageBlocks.length) {
        [...imageBlocks].forEach((el) => {
          el.setAttribute('aria-expanded', 'false');
        });

        on('click', '.js-image-block', (e) => {
          e.preventDefault();
          const item = e.currentTarget;
          const parent = item.closest('.image-block');
          const items = parent.querySelectorAll('.js-image-block');

          if (item.classList.contains('is-active')) {
            const href = item.querySelector('.image-block__cta').getAttribute('href');
            // Go to the link, only on desktop view
            if (href != null && helpers.breakpoint(parent) !== 'mobile') {
              window.location = href;
            } else {
              e.currentTarget.classList.remove('is-active');
              e.currentTarget.setAttribute('aria-expanded', 'false');
              return;
            }
          }

          [...items].forEach((el) => {
            el.classList.remove('is-active');
            el.setAttribute('aria-expanded', 'false');
          });

          e.currentTarget.classList.add('is-active');
          e.currentTarget.setAttribute('aria-expanded', 'true');
        });

        on('click', '.image-block__additional-cta a', (e) => {
          e.stopPropagation();
        });
      }
    },
  };
}());
